angular.module('impactx.deliverycomplaint').directive('appComplaintItem', function(){
    return {
        restrict: 'E',
        transclude: true,
        templateUrl: 'modules/deliverycomplaint/templates/complaintitem.tmpl.html',
        scope: {
            complaintItem : '=',
            selectedComplaintItems: '=',
            trns : '=',
            readOnly: '=',
            form: '=',
            showComments: '=',
            onDelete: '=',
            isClosed: "="
        }
    }
});